import { useState, memo } from "react";
import { Button, Tooltip } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiltersPopover from "./FiltersPopover";
import { useMainContext } from "../../../../../context/useMainContext";

const FilterSection = memo(function FilterSection() {
  const { isGuest } = useMainContext();
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  return (
    <>
      <Tooltip title="Filters">
        <Button
          variant="outlined"
          onClick={(e) => setFiltersAnchorEl(e.currentTarget)}
          disabled={isGuest}
          sx={{ px: 1 }}
        >
          <FilterListIcon />
        </Button>
      </Tooltip>

      <FiltersPopover filtersAnchorEl={filtersAnchorEl} setFiltersAnchorEl={setFiltersAnchorEl} />
    </>
  );
});

export default FilterSection;
